import { utils, write, WorkBook, WorkSheet } from 'xlsx';
import { saveAs } from 'file-saver';

type SheetMap = Record<string, any[]>;

export const downloadAsExcel = (data: any[], filename: string) => {
  try {
    const ws = utils.json_to_sheet(data);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Sheet1');

    const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    saveAs(blob, `${filename}.xlsx`);
  } catch (err) {
    console.error('Failed to download excel file:', err);
  }
};

export const downloadMultiSheetExcel = (sheets: SheetMap, filename: string) => {
  try {
    const wb: WorkBook = utils.book_new();

    Object.entries(sheets).forEach(([sheetName, rows]) => {
      const ws: WorkSheet = utils.json_to_sheet(rows);

      // 선택: 간단한 컬럼 폭 지정 (가독성)
      const maxKeys = rows.length ? Object.keys(rows[0]).length : 0;
      ws['!cols'] = Array.from({ length: maxKeys }).map(() => ({ wch: 16 }));

      utils.book_append_sheet(wb, ws, sheetName.slice(0, 31)); // 엑셀 시트명 31자 제한
    });

    const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `${filename}.xlsx`);
  } catch (err) {
    console.error('Failed to download excel file:', err);
  }
};
